import { fetchUser } from "actions/user";
import RequireData from "hooks/RequireData";
import SageScreen from "kit/SageScreen";
import React from "react";
import { Link } from "react-router-dom";
import fetchUserStatusSelector from "selectors/fetchUserStatus";
import userSelector from "selectors/user";
import { centHundredthsToString } from "utils/moneyFormat";
import styles from "./BalanceMoney.module.scss";
import classnames from "classnames";
import BalanceMoneyPage from "./balanceMoney/BalanceMoneyPage";

const BalanceMoney: React.FC = () => {
    const [user] = RequireData(
        userSelector,
        fetchUserStatusSelector,
        fetchUser()
    );

    const [page, setPage] = React.useState(0);

    const incrementPage = React.useCallback(() => {
        setPage(page + 1);
    }, [page, setPage]);

    const decrementPage = React.useCallback(() => {
        setPage(Math.max(0, page - 1));
    }, [page, setPage]);

    return (
        <SageScreen>
            <h2>
                Money Balance:{" "}
                {user === null
                    ? "loading..."
                    : centHundredthsToString(
                          user.money_balance_cent_hundredths
                      )}
            </h2>
            <Link
                className={classnames(
                    styles.rightMarginButton,
                    "btn btn-outline-secondary btn-sm"
                )}
                to="/home/dashboard/balance/money/transfer"
            >
                Transfer to Bank
            </Link>
            <Link
                className={classnames(
                    styles.rightMarginButton,
                    "btn btn-outline-secondary btn-sm"
                )}
                to="/home/dashboard/balance/money/view-transfers"
            >
                View Transfers
            </Link>
            <Link
                to="/home/dashboard/balance/money/add"
                className={classnames(
                    styles.rightMarginButton,
                    "btn btn-outline-secondary btn-sm"
                )}
            >
                Add Money
            </Link>
            <hr />
            <BalanceMoneyPage
                incrementPage={incrementPage}
                decrementPage={decrementPage}
                page={page}
            />
        </SageScreen>
    );
};

export default BalanceMoney;
